import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { BarLoader } from 'react-spinners';
import Input from '../Input/Input';
import Select from '../Select/Select';

class PressureSensorInstallForm extends React.Component {
  render() {
    const {
      isWorking,
      position,
      sopId,
      loggerTypes,
      handleSubmit,
      pristine,
      submitting,
      user,
    } = this.props;

    const hasPosition = position && position.length === 2;
    let positionText;
    if (!hasPosition) {
      positionText = this.context.t('click_map_to_select_location');
    } else if (sopId) {
      positionText = `${position[1].toFixed(6)}, ${position[0].toFixed(6)} (Existing SOP)`;
    } else {
      positionText = `${position[1].toFixed(6)}, ${position[0].toFixed(6)}`;
    }

    return (
      <form className='form-horizontal sticky-actions' onSubmit={handleSubmit} style={{ padding: '10px', paddingLeft: '5px' }}>
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
          }}
        >
          <BarLoader color='#4cae4c' width='110%' loading={isWorking} />
        </div>


        <div className='form-group' style={{ marginLeft: 0, marginRight: 0 }}>
          <label className='col-xs-3 control-label' style={{ paddingLeft: 0, paddingRight: '5px' }}>
            {this.context.t('position')}:
          </label>
          <div className='col-xs-6' style={{ paddingLeft: '5px', paddingRight: 0 }}>
            <input
              type='text'
              className='form-control'
              value={positionText}
              disabled={true}
              style={{ backgroundColor: hasPosition ? '#dff0d8' : '#f2dede' }}
            />
          </div>
        </div>

        <div className='form-group' style={{ marginLeft: 0, marginRight: 0 }}>
          <label className='col-xs-3 control-label' style={{ paddingLeft: 0, paddingRight: '5px' }}>
            {this.context.t('device_id')}:
          </label>
          <div className='col-xs-6' style={{ paddingLeft: '5px', paddingRight: 0 }}>
            <Field
              name='deviceId'
              component={Input}
              type='text'
              placeholder={this.context.t('device_id_placeholder')}
              disabled={!user.editMode}
            />
          </div>
        </div>

        <div className='form-group' style={{ marginLeft: 0, marginRight: 0 }}>
          <label className='col-xs-3 control-label' style={{ paddingLeft: 0, paddingRight: '5px' }}>
            {this.context.t('logger_type')}:
          </label>
          <div className='col-xs-6' style={{ paddingLeft: '5px', paddingRight: 0 }}>
            <Field
              name='loggerType'
              component={Select}
              options={loggerTypes}
              disabled={!user.editMode}
            />
          </div>
        </div>

        <div className='form-group' style={{ marginLeft: 0, marginRight: 0 }}>
          <div className='col-xs-6' style={{ paddingLeft: '5px', paddingRight: 0, marginLeft: '25%' }}>
            <div className='actions-panel'>
              <button
                type='submit'
                className='btn btn-success'
                disabled={!hasPosition || pristine || submitting || !user.editMode}
              >
                {this.context.t('install_pressure_sensor')}
              </button>
              <button
                type='button'
                className='btn btn-warning'
                style={{ marginLeft: '5px' }}
                onClick={this.props.onCancel}
              >
                {this.context.t('cancel')}
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

PressureSensorInstallForm.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'pressureSensorInstallForm',
  enableReinitialize: true,
})(PressureSensorInstallForm);
